<div class="part-number-changes-credentials-wrapper">
  <div [ngClass]="{'pnc-credentials-view-mode': isViewMode()}">
    @if (isViewMode()) {
      <app-part-number-changes-detail-title [sectionTitle]="sectionTitle"></app-part-number-changes-detail-title>
      <div class="pnc-credentials-country-section">
        <div class="pnc-detail-body-output-field-label pnc-credentials-country-section-gap" data-cy="pnc-form-country-label">{{labelRegion}}</div>
        <div class="pnc-detail-body-output-field-value" data-cy="pnc-form-country-value">{{$safeNavigationMigration(credentials?.country) | undefinedValue}}</div>
      </div>
    }

    <div class="{{partnerSectionClass}}"
      data-cy="pnc-create-form-credentials-separator">
      <app-input-dropdown #partnerInput
        (inputStateChange)="managePartnerInputStateChange($event)"
        (inputValueChange)="setPartnerValue($event)"
        [initialValue]="$safeNavigationMigration(credentials?.partner)"
        [showViewMode]="isViewMode()"
        [alternateBackground]="hasAlternateBackground"
        [inputFormatter]="typeahead.inputTextCodeNameFormatter"
        [messages]="partnerInputMessages"
        [resultFormatter]="typeahead.inputTextCodeNameFormatter"
        [resultsFunction]="searchPartners"
        [validators]="validators.partner"
        [warningLevel]="WarningsEnum.WARNING_CREATE"
        baseCypressTag="pnc-form-partner"
        label="Partner"
      placeholder="Select a partner"></app-input-dropdown>
      <app-input-dropdown #shipToPartyInput
        (inputStateChange)="manageShipToPartyInputStateChange($event)"
        (inputValueChange)="setShipToPartyValue($event)"
        [initialValue]="$safeNavigationMigration(credentials?.shipToParty)"
        [showViewMode]="isViewMode()"
        [alternateBackground]="hasAlternateBackground"
        [inputFormatter]="typeahead.inputTextCodeNameFormatter"
        [messages]="shipToPartyInputMessages"
        [resultFormatter]="typeahead.inputTextCodeNameFormatter"
        [resultsFunction]="searchShipToParty"
        [validators]="validators.shipToParty"
        [warningLevel]="WarningsEnum.WARNING_CREATE"
        baseCypressTag="pnc-form-ship-to-party"
        label="Ship to party"
      placeholder="Select a ship to party"></app-input-dropdown>
    </div>

    <div class="{{supplyingPackingPlantClass}}"
      data-cy="pnc-create-form-credentials-separator">
      <app-input-dropdown #supplyingPackingPlantInput
        (inputStateChange)="manageSupplyingPackingPlantInputStateChange($event)"
        (inputValueChange)="setSupplyingPackingPlantValue($event)"
        [initialValue]="$safeNavigationMigration(credentials?.supplyingPackingPlant)"
        [showViewMode]="isViewMode()"
        [alternateBackground]="hasAlternateBackground"
        [inputFormatter]="typeahead.inputTextCodeNameFormatter"
        [messages]="supplyingPackingPlantInputMessages"
        [resultFormatter]="typeahead.inputTextCodeNameFormatter"
        [resultsFunction]="searchSupplyingPackingPlants"
        [validators]="validators.supplyingPackingPlant"
        [warningLevel]="WarningsEnum.WARNING_CREATE"
        baseCypressTag="pnc-form-supplying-packing-plant"
        label="Supplying packing plant"
      placeholder="Select a supplying packing plant"></app-input-dropdown>
    </div>
  </div>

  @if (isViewMode()) {
    <div class="pnc-status-timeline-wrapper">
      <app-status-timeline [configuration]="mapStatusTimelineToConfigurationModel()"></app-status-timeline>
    </div>
  }
</div>
